/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Tool_Get_Project_TemplateInputs */



/**
* | output |
* | --- |
* | "Reading template" |
*
* @param {Uno_Tool_Get_Project_TemplateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_tool_get_project_template = /** @type {((inputs?: Uno_Tool_Get_Project_TemplateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Tool_Get_Project_TemplateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Lese Vorlage")
	return /** @type {LocalizedString} */ ("Reading template")
});